module.exports = __webpack_public_path__ + "img/水杯3.352544e9.png";